// -------------------------------------------------------------------------------------------------
// Import
// -------------------------------------------------------------------------------------------------



// -------------------------------------------------------------------------------------------------
// Variables
// -------------------------------------------------------------------------------------------------

const baseClass = 'ume-random-modal iframe';

// -------------------------------------------------------------------------------------------------
// Classes
// -------------------------------------------------------------------------------------------------

class modalClass {
  constructor(el) {
    this.el = el;
    this.checkHasIframe(el);
  }

  checkHasIframe(el) {
    if (jQuery(el).closest('.wp-block-embed').length == 0) {
      jQuery(el).wrapAll('<div class="modal-body__iframe"></div>');
    }
  }
}

// -------------------------------------------------------------------------------------------------
// Methods
// -------------------------------------------------------------------------------------------------

function init() {
  jQuery(`.${baseClass}`).each((i, el) => new modalClass(el));
}

// -------------------------------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------------------------------

export default {
  init,
};